
const OutletRoutes = [
  {
    path: '/ecommerce/outlets',
    name: 'outlets',
    component: () => import(/* webpackChunkName: "outlet" */ './views/OutletView.vue'),
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        {
          name: 'Outlets',
          path: '/ecommerce/outlets',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'outlets',
        component: () => import(/* webpackChunkName: "outlet" */ './components/Outlets.vue'),
        meta: {
          breadCrumbs: [
            {
              name: 'Outlets',
              path: '/ecommerce/outlets',
            },
          ],
        },
      },
      {
        path: ':id/details',
        name: 'outlet-details',
        component: () => import(/* webpackChunkName: "outlet" */ './components/OutletDetails.vue'),
        meta: {
          requiresAuth: true,
          breadCrumbs: [
            {
              name: 'Outlet Details',
              path: '/ecommerce/outlets/:id/details',
            },
          ],
        },
      },
    ],
  },
];

export default OutletRoutes;
